/* eslint-disable react/jsx-props-no-spreading */
import { uuid } from '@tvg/fuse-utils';
import PropTypes from 'prop-types';
import React from 'react';
import checkboxConfig from './checkbox-config';
import {
	StyledCheckbox,
	StyledCheckboxError,
	StyledCheckboxInput,
	StyledErrorIcon,
	StyledErrorText,
} from './styled-checkbox';

const { forwardRef, useMemo } = React;

const propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	name: PropTypes.string.isRequired,
	analyticsId: PropTypes.string,
	className: PropTypes.string,
	dataTestId: PropTypes.string,
	errorMessage: PropTypes.string,
	fullWidth: PropTypes.bool,
	isChecked: PropTypes.bool,
	isDisabled: PropTypes.bool,
	marginBottom: PropTypes.bool,
	onChange: PropTypes.func,
	style: PropTypes.object,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	componentId: PropTypes.string,
};

const defaultProps = {
	analyticsId: '',
	className: '',
	dataTestId: '',
	errorMessage: '',
	fullWidth: false,
	isChecked: false,
	isDisabled: false,
	marginBottom: false,
	onChange: undefined,
	style: undefined,
	value: '',
	componentId: uuid(),
};

export const Checkbox = forwardRef(
	(
		{ className, dataTestId, errorMessage, fullWidth, marginBottom, style, componentId, ...props },
		ref,
	) => {
		const { errorIcon, errorText } = checkboxConfig;
		// Populate errorMessageId only if there is error message, and pass this to base input aria-describedby
		const errorMessageId =
			errorMessage && useMemo(() => `${componentId}-${errorText.className}-${errorMessage}`);

		return (
			<StyledCheckbox
				className={className}
				data-testid={dataTestId || 'fuse-checkbox'}
				fullWidth={fullWidth}
				marginBottom={marginBottom}
				ref={ref}
				style={style}				
			>
				<StyledCheckboxInput
					componentId={componentId}
					errorMessageId={errorMessageId || undefined}
					isError={!!errorMessage}
					{...props}
				/>
				{errorMessage && (
					<StyledCheckboxError>
						<StyledErrorIcon
							icon={errorIcon.icon}
							color={errorIcon.color}
							className={errorIcon.className}
							data-testid={errorIcon.dataTestId}
							responsiveSize={errorIcon.size}
						/>
						<StyledErrorText
							id={errorMessageId}
							color={errorText.color}
							className={errorText.className}
							dataTestId={errorText.dataTestId}
							size={errorText.size}
							tag={errorText.tag}
							type={errorText.type}
						>
							{errorMessage}
						</StyledErrorText>
					</StyledCheckboxError>
				)}
			</StyledCheckbox>
		);
	},
);

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;

export default Checkbox;
